import { MaterialsFormFieldsTypes } from "../forms/forms-fields/materials-form-fields";

export enum ExhibitionTimeFilter {
  ALL = "all",
  PAST = "past",
  FUTURE_OR_ONGOING = "future-or-ongoing",
}

export interface ExhibitionFinderFiltersFormTypes extends MaterialsFormFieldsTypes {
  location: string;
  time: ExhibitionTimeFilter;
  search: string;
}
